import {
  Modal,
  Row,
  Col,
  Table,
  FloatButton,
  Spin,
  message,
  Tag,
  Button,
  Space,
} from "antd";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_CREATE_PAYMENT_INVESTIGATE,
  POST_MAIN_ASSET_BY_DATE,
} from "../../../API/apiUrls";
import axios from "axios";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

const ListDataPayment = ({ open, close, dataLoad, func, status }) => {
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const scrollRef = useRef(null);

  const handleCancel = () => close(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    const customDataNew = customData(dataLoad);
    console.log("customDataNew", customDataNew);
    console.log("flatRows", dataLoad);

    setArrayTable(customDataNew);
    setLoading(false);
    // const payload = {
    //   date1: dayjs(dataLoad.dateRound).startOf("month").format("YYYY-MM-DD"),
    //   date2: dayjs(dataLoad.dateRound).endOf("month").format("YYYY-MM-DD"),
    // };

    // try {
    //   const [res1] = await Promise.all([
    //     axios.post(BASE_URL_BEN + POST_MAIN_ASSET_BY_DATE, payload, {
    //       headers: HEADERS_EXPORT_BEN,
    //     }),
    //   ]);

    //   if (res1.data?.success === "ไม่พบข้อมูล") {
    //     message.warning("ไม่พบข้อมูลสืบทรัพย์");
    //     setArrayTable([]);
    //     return;
    //   }
    //   const formattedData = res1.data.map((item, index) => ({
    //     ...item,
    //     key: index + 1,
    //   }));

    // } catch (error) {
    //   console.error("Error loading data:", error);
    //   message.error(`ไม่พบข้อมูล: ${error.message}`);
    //   setArrayTable([]);
    // } finally {
    //   setLoading(false);
    // }
  };

  const sendStatus = async () => {
    try {
      const res = await axios.post(
        POST_CREATE_PAYMENT_INVESTIGATE,
        arrayTable,
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );

      if (res.status === 200) {
        console.log("resQuery", res.data);
        func(true);
        handleCancel();
      } else return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
    } catch (error) {
      console.error("Error sending data:", error);
      message.error("ไม่สามรถทำรายการได้");
      const errorMessage =
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
      return { success: false, error: errorMessage };
    }
  };

  // SCHEMA → group mapping
  const SCHEMA_GROUP = {
    sfhp: "group1",
    vsfhp: "group2",
    lsfhp: "group3",
    rpsl: "group3",
    psfhp: "group3",
  };
  // ── แปลง loan 1 รายการ (พร้อม data[].money) เป็น flat row ──
  const flattenLoan = (loan) => {
    const persons = loan.data || [];

    // invId และ invRoundId อาจต่างกันในแต่ละ person → ใช้ของคนแรก
    const firstPerson = persons[0] || {};

    // sum money จากทุกคนใน loan นี้
    const sumAdditionalFee = persons.reduce(
      (s, r) => s + Number(r.money?.additionalFee || 0),
      0,
    );
    const sumFamilyReg = persons.reduce(
      (s, r) => s + Number(r.money?.familyRegistration || 0),
      0,
    );
    const sumOperationFee = persons.reduce(
      (s, r) => s + Number(r.money?.operationFee || 0),
      0,
    );
    const sumSpouseFee = persons.reduce(
      (s, r) => s + Number(r.money?.spouseFee || 0),
      0,
    );
    const sumTr14 = persons.reduce((s, r) => s + Number(r.money?.tr14 || 0), 0);

    const totalNew =
      sumAdditionalFee +
      sumFamilyReg +
      sumOperationFee +
      sumSpouseFee +
      sumTr14;
    if (!totalNew) {
      return;
    }
    return {
      invRoundId: firstPerson.invRoundId,
      invId: firstPerson.invId,
      NETAMT: totalNew,
      CONTNO: loan.contno,
      CUSTNAME: loan.SNAM + loan.NAME1 + loan.NAME2,
      dateRound: loan.dateOnlineInvestigate,
      USERID: "BELL",
      dtrPaymentId: loan.dtrPaymentId,
    };
  };

  // ── จัดกลุ่มตาม SCHEMA ────────────────────────────────────────
  const customData = (data) => {
    const result = { group1: [], group2: [], group3: [] };

    data.forEach((loan) => {
      const group = SCHEMA_GROUP[loan.SCHEMA];
      if (!group) return;

      const row = flattenLoan(loan);
      if (!row) return; // ← totalNew = 0 → ไม่ push

      result[group].push(row);
    });

    return result;
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "CUSTNAME",
      align: "center",
      render: (_, record) => record.CUSTNAME,
    },
    {
      title: "สถานะ",
      key: "garno",
      align: "center",
      render: (_, record) => (
        <Tag color={record.dtrPaymentId ? "green" : "red"}>
          {" "}
          {record.dtrPaymentId ? "ตั้งเบิกแล้ว" : "ยังไม่ตั้งเบิก"}
        </Tag>
      ),
    },
  ];

  const GROUP_LABEL = {
    group1: {
      label: "บัญชี V,8",
      color: "#185FA5",
      bg: "#E6F1FB",
      textColor: "#0C447C",
    },
    group2: {
      label: "บัญชี 2 ",
      color: "#0F6E56",
      bg: "#E1F5EE",
      textColor: "#085041",
    },
    group3: {
      label: "บัญชี 1, P-LOAN, 3 เก่า",
      color: "#854F0B",
      bg: "#FAEEDA",
      textColor: "#633806",
    },
  };

  const fmt = (n) =>
    Number(n || 0).toLocaleString("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const TableByGroup = ({ groupedData, columns }) => {
    const grandTotal = Object.values(groupedData)
      .flat()
      .reduce((s, r) => s + Number(r.NETAMT || 0), 0);

    const grandCount = Object.values(groupedData).reduce(
      (s, g) => s + g.length,
      0,
    );

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        {Object.entries(GROUP_LABEL).map(
          ([groupKey, { label, color, bg, textColor }]) => {
            const rows = groupedData[groupKey] || [];
            if (!rows.length) return null;

            const groupTotal = rows.reduce(
              (s, r) => s + Number(r.NETAMT || 0),
              0,
            );

            return (
              <div key={groupKey}>
                {/* ── Group header ── */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 16px",
                    backgroundColor: bg,
                    border: `0.5px solid ${color}`,
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 10 }}
                  >
                    <div
                      style={{
                        width: 5,
                        height: 20,
                        backgroundColor: color,
                        borderRadius: 2,
                      }}
                    />
                    <span
                      style={{
                        fontWeight: 500,
                        fontSize: 15,
                        color: textColor,
                      }}
                    >
                      {label}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                        padding: "2px 10px",
                        backgroundColor: color,
                        color: "#fff",
                        borderRadius: 20,
                      }}
                    >
                      {rows.length} รายการ
                    </span>
                  </div>
                  <span
                    style={{ fontWeight: 500, fontSize: 15, color: textColor }}
                  >
                    {fmt(groupTotal)} บาท
                  </span>
                </div>

                {/* ── Table ── */}
                <Table
                  size="middle"
                  rowKey={(r) => r.invId ?? r.CONTNO}
                  columns={columns}
                  dataSource={rows}
                  pagination={false}
                  bordered
                  style={{
                    borderRadius: "0 0 8px 8px",
                    overflow: "hidden",
                    border: `0.5px solid ${color}`,
                    borderTop: "none",
                  }}
                  footer={null}
                />
              </div>
            );
          },
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 24px",
            backgroundColor: "var(--color-background-secondary, #f8f9fa)",
            border: "1px solid var(--color-border-secondary, #e9ecef)",
            borderRadius: 8,
            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
            marginBottom: "20px",
          }}
        >
          {/* ฝั่งซ้าย: จำนวนรายการ */}
          <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
            <span
              style={{
                fontSize: 14,
                color: "var(--color-text-secondary, #6c757d)",
              }}
            >
              จำนวนทั้งหมด:
            </span>
            <span
              style={{
                fontWeight: 600,
                fontSize: 16,
                color: "var(--color-text-primary, #212529)",
              }}
            >
              {grandCount}{" "}
              <span style={{ fontSize: 14, fontWeight: 400 }}>รายการ</span>
            </span>
          </div>

          {/* ฝั่งขวา: ยอดรวมเงิน (เน้นตัวใหญ่ขึ้น) */}
          <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
            <span
              style={{
                fontSize: 14,
                color: "var(--color-text-secondary, #6c757d)",
              }}
            >
              รวมทั้งสิ้น:
            </span>
            <span
              style={{
                fontWeight: 700,
                fontSize: 20,
                color: "var(--color-text-primary, #212529)",
              }}
            >
              {fmt(grandTotal)}{" "}
              <span style={{ fontSize: 14, fontWeight: 400 }}>บาท</span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Spin spinning={loading} size="large" tip="Loading...">
      <Modal
        title={
          <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
            รายการตั้งเบิก
          </span>
        }
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
        keyboard={true}
        centered
        styles={{ body: { padding: "24px 32px" } }}
      >
        <div
          ref={scrollRef}
          style={{ maxHeight: 800, overflow: "auto", position: "relative" }}
        >
          <TableByGroup groupedData={arrayTable} columns={columns} />
          <div style={{ textAlign: "center" }}>
            <Space size={30}>
              <Button
                size="large"
                danger
                icon={<CloseCircleOutlined />}
                onClick={handleCancel}
                loading={loading}
              >
                ปิด
              </Button>

              <Button
                size="large"
                type="primary"
                icon={<CheckCircleOutlined />}
                onClick={sendStatus}
                loading={loading}
                disabled={status === 2}
              >
                อนุมัติ
              </Button>
            </Space>
          </div>
          <FloatButton.BackTop
            target={() => scrollRef.current}
            visibilityHeight={80}
            style={{ right: 16, bottom: 16 }}
          />
        </div>
      </Modal>
    </Spin>
  );
};

export default ListDataPayment;
